import styled, { css, useTheme } from 'foundations-theming-specialty/utils';
import { GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH } from 'nav-meta/constants';
import { useLayoutEffect, useState } from 'react';
import { TOOLTIP_HEIGHT } from './constants';
import { ArrowContainer } from '../../nav-ui-components/ArrowContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledArrowContainer = styled(ArrowContainer)(({
  $topOffset,
  theme
}) => {
  return css(["position:fixed;top:", ";left:calc( var( --global-nav-vertical-nav-width,", " ) + 8px );box-shadow:", ";"], `${$topOffset}px`, GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_COLLAPSED_WIDTH, theme.boxShadow['400']);
});
const arrowStyles = theme => css(["background:", ";"], theme.color['global-shell-fill-surface-panel-default']);
const StyledInnerContainer = styled.div.withConfig({
  displayName: "VerticalNavMenuItemTooltip__StyledInnerContainer",
  componentId: "sc-1fs9kgh-0"
})(({
  theme
}) => {
  return css(["background:", ";border-radius:3px;color:", ";padding:0 16px;white-space:nowrap;font-size:14px;font-weight:300;line-height:24px;text-align:left;height:", "px;display:flex;align-items:center;"], theme.color['global-shell-fill-surface-panel-default'], theme.color['global-shell-text-nav-item-default'], TOOLTIP_HEIGHT);
});
const VerticalNavMenuItemTooltip = ({
  label,
  buttonRef
}) => {
  const theme = useTheme();
  const [topOffset, setTopOffset] = useState(0);
  useLayoutEffect(() => {
    if (buttonRef.current) {
      const button = buttonRef.current.getBoundingClientRect();
      setTopOffset(button.top + (button.height / 2 - TOOLTIP_HEIGHT / 2));
    }
  }, [buttonRef]);
  return /*#__PURE__*/_jsx(StyledArrowContainer, {
    arrowPosition: "left",
    arrowSize: 8,
    arrowStyles: arrowStyles(theme),
    "aria-hidden": true,
    $topOffset: topOffset,
    children: /*#__PURE__*/_jsx(StyledInnerContainer, {
      children: label
    })
  });
};
export default VerticalNavMenuItemTooltip;